import { trackUtm } from './utm-tracking';

// Runs synchronously on bundle load so cookies exist before any domReady consumer (GTM, forms) reads them.
// Only tracks when a GTM ID is set, so environments without GTM don't write tracking cookies.
if (window.productiveBlocks?.utmTrackingEnabled) {
	trackUtm();
}
